import { topics } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
              热门话题
            </span>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">
              大家都在看
            </h2>
            <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
              最受影迷关注的热门电影话题与类型标签
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic) => (
              <a
                key={topic.id}
                href="#carousel"
                className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer ${
                  topic.hot
                    ? 'bg-accent-500 text-background-50 hover:bg-accent-600'
                    : 'bg-background-50 text-foreground-600 border border-background-200/70 hover:border-accent-300 hover:text-accent-700'
                }`}
              >
                {topic.hot && <i className="ri-fire-line text-xs"></i>}
                <span>{topic.name}</span>
                <span className={`text-xs px-1.5 py-0.5 rounded-full ${
                  topic.hot ? 'bg-background-50/20 text-background-50' : 'bg-background-100 text-foreground-400'
                }`}>
                  {topic.count}
                </span>
              </a>
            ))}
          </div>

          <div className="text-center mt-6">
            <p className="text-xs text-foreground-400">
              以上标签数据基于近30日影迷浏览热度统计，每日自动更新
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}